<template>
  <div :class="{'spl-parcel-detail-block-vertical': vertical, 'spl-parcel-detail-block-error': error, 'spl-parcel-detail-block-editing': isEditing}" class="spl-parcel-detail-block">
    <div class="spl-parcel-detail-block__label">
      Address Info
    </div>
    <div
      v-if="userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.UPDATE)"
      :class="{'spl-parcel-detail-block__edit-open': isEditing}"
      class="spl-parcel-detail-block__edit"
      @click="toggleEditable" />
    <div class="spl-parcel-detail-block__body">
      <div class="row">
        <div class="col6">
          <!-- *********************** Pickup Address  *********************************** -->
          <div :class="{'spl-parcel-detail-block__body__content-blocks': contentBlocks, 'spl-parcel-detail-block__body__content-edit': isEditing}" class="spl-parcel-detail-block__body__content">
            <div class="spl-parcel-detail-block__body__content__label">
              Pickup Address
            </div>
            <div
              v-if="!isEditing"
              class="spl-parcel-detail-block__body__content__value spl-parcel-detail-block__body__content__value-pre">
              {{ pickup_address }}
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="isEditing"
        class="row">
        <div class="col10">
          <div :class="{'spl-parcel-detail-block__body__content-blocks': contentBlocks, 'spl-parcel-detail-block__body__content-edit': isEditing}" class="spl-parcel-detail-block__body__content">
            <div v-if="isEditing" class="spl-parcel-detail-block__body__content__value">
              <!-- *********************** Select the pickup address  ***********************************-->
              <form-filtered-select
                :selected-key="temp_parcel_json.Pickup_Address_ID"
                :options="found_pickup_addresses"
                :internal-search="false"
                placeholder="Search for Addresses..."
                icon="search"
                no-options="Type at least 3 characters to start search"
                class="spl-parcel-detail-block__pickup-address"
                data-cy="detail-select-pickup-address"
                @search-change="getAddresses($event, 'pickup')"
                @updateDropdownValue="update_Pickup_Address" />
              <div
                v-if="isEditing"
                class="spl-parcel-detail-block__body__content__value spl-parcel-detail-block__body__content__value-pre"
                data-cy="detail-pickup-address">
                {{ pickup_address }}
              </div>
            </div>
          </div>
        </div>
        <!-- *********************** Show Address Editing  *********************************** -->
        <div class="col1">
          <form-button
            v-if="isEditing"
            data-cy="detail-edit-pickup-address"
            @onClick="show_Create_Pickup_Address">
            Edit
          </form-button>
          <edit-create-address-modal
            :address-model="temp_parcel_json.Pickup_Address"
            :customer-key="parcel_json.Customer_ID"
            :is-visible="create_pickup_address_shown"
            @close="close_Address"
            @address_Created="pickup_Address_Created" />
        </div>
      </div>
      <div class="row">
        <div class="col6">
          <!-- *********************** Delivery Address  *********************************** -->
          <div :class="{'spl-parcel-detail-block__body__content-blocks': contentBlocks, 'spl-parcel-detail-block__body__content-edit': isEditing}" class="spl-parcel-detail-block__body__content">
            <div class="spl-parcel-detail-block__body__content__label">
              Delivery Address
            </div>
            <!-- *********************** Show Address not editing  *********************************** -->
            <div
              v-if="!isEditing"
              class="spl-parcel-detail-block__body__content__value spl-parcel-detail-block__body__content__value-pre">
              {{ delivery_address }}
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="isEditing"
        class="row">
        <!-- *********************** Delivery Fields  *********************************** -->
        <div class="col10">
          <div :class="{'spl-parcel-detail-block__body__content-blocks': contentBlocks, 'spl-parcel-detail-block__body__content-edit': isEditing}" class="spl-parcel-detail-block__body__content">
            <div v-if="isEditing" class="spl-parcel-detail-block__body__content__value">
              <!-- *********************** Select the delivery address *********************************** -->
              <form-filtered-select
                :selected-key="temp_parcel_json.Delivery_Address_ID"
                :options="found_delivery_addresses"
                :internal-search="false"
                placeholder="Search for Addresses..."
                icon="search"
                no-options="Type at least 3 characters to start search"
                class="spl-parcel-detail-block__delivery-address"
                data-cy="detail-select-delivery-address"
                @search-change="getAddresses($event, 'delivery')"
                @updateDropdownValue="update_Delivery_Address" />
              <!-- *********************** Show Address Editing  *********************************** -->
              <div
                v-if="isEditing"
                class="spl-parcel-detail-block__body__content__value spl-parcel-detail-block__body__content__value-pre"
                data-cy="detail-delivery-address">
                {{ delivery_address }}
              </div>
            </div>
          </div>
        </div>
        <!-- *********************** Show Address Editing  *********************************** -->
        <div class="col1">
          <form-button
            v-if="isEditing"
            data-cy="detail-edit-delivery-address"
            @onClick="show_Create_Delivery_Address">
            Edit
          </form-button>

          <edit-create-address-modal
            :address-model="temp_parcel_json.Delivery_Address"
            :customer-key="parcel_json.Customer_ID"
            :is-visible="create_delivery_address_shown"
            @close="close_Address"
            @address_Created="delivery_Address_Created" />
        </div>
      </div>

      <div class="row spl-parcel-detail-block__body__content">
        <div v-if="!isEditing" class="col12 spl-parcel-detail-block__body__content__label">
          Contact
        </div>
      </div>
      <contact-component
        :parcel-data="parcel_json"
        :is-selecting="isEditing"
        form-style="detail"
        @contactSelected="contactSet" />

      <div class="spl-parcel-detail-block__body__content">
        <!-- *********************** Delivery Information  *********************************** -->
        <div class="">
          Additional Information
        </div>
        <!-- *********************** Show Delivery Information not editing  *********************************** -->
        <div class="">
          {{ delivery_information }}
        </div>
      </div>

      <div v-if="isEditing" class="row">
        <div class="col6">
          <form-button
            wide="true"
            secondary="true"
            @onClick="close">
            Cancel
          </form-button>
        </div>
        <div class="col6">
          <form-button
            :disabled="saving"
            wide="true"
            @onClick="save">
            Save
          </form-button>
        </div>
      </div>
    </div>
    <div v-if="highlight" class="spl-parcel-detail-block__highlight">
      {{ highlight }}
    </div>
  </div>
</template>

<script lang="ts">
import Helpers from '@/helpers.vue'
import webApi from '@/webApi'
import { SearchAddressModel } from '@/webApi/DataModels'
import constants from '@/constants'
import { cloneDeep, debounce } from 'lodash'
export default {
  name: 'ParcelDetailBlockAddress',
  mixins: [Helpers],
  props: [
    'label',
    'highlight',
    'error',
    'contentBlocks',
    'vertical',
    'originalParcelJson',
    'editInProgress'
  ],
  data () {
    return {
      isEditing: false,
      temp_parcel_json: cloneDeep(this.originalParcelJson),
      found_pickup_addresses: [],
      found_delivery_addresses: [],
      constants,
      create_pickup_address_shown: false,
      create_delivery_address_shown: false,
      saving: false,
      currentSearchDebounce: null
    }
  },
  computed: {
    parcel_json () {
      return this.originalParcelJson
    },

    // ************************ Format the pickup a ddress ************************
    pickup_address () {
      let tmpPickupValue = ''
      if (this.temp_parcel_json.Pickup_Address) {
        tmpPickupValue = this.temp_parcel_json.Pickup_Address.Name_1
        tmpPickupValue += '\n ' + this.temp_parcel_json.Pickup_Address.Street_1
        tmpPickupValue += '\n ' + this.temp_parcel_json.Pickup_Address.Postal_Code + ' ' + this.temp_parcel_json.Pickup_Address.City
        tmpPickupValue += '\n ' + this.temp_parcel_json.Pickup_Address.Country_Name
      }
      return tmpPickupValue
    },

    // ************************ Format the delivery a ddress ************************
    delivery_address () {
      let tmpDeliveryValue = ''
      if (this.temp_parcel_json.Delivery_Address) {
        tmpDeliveryValue = this.temp_parcel_json.Delivery_Address.Name_1
        tmpDeliveryValue += '\n ' + this.temp_parcel_json.Delivery_Address.Street_1
        tmpDeliveryValue += '\n ' + this.temp_parcel_json.Delivery_Address.Postal_Code + ' ' + this.temp_parcel_json.Delivery_Address.City
        tmpDeliveryValue += '\n ' + this.temp_parcel_json.Delivery_Address.Country_Name
      }
      return tmpDeliveryValue
    },

    delivery_information () {
      return this.temp_parcel_json.Delivery_Information
    }
  },
  mounted () {
    // populate the addresses array with the already selected addresses
    this.addFoundAddress(this.temp_parcel_json.Delivery_Address, 'delivery')
    this.addFoundAddress(this.temp_parcel_json.Pickup_Address, 'pickup')
  },
  methods: {
    // ************************ If the window is closed everything is reset************************
    close () {
      this.isEditing = false
      window.bus.$emit('edit_in_progress')
      // Resets the parcel json
      this.$set(this.temp_parcel_json, 'Pickup_Address_ID', this.parcel_json.Pickup_Address_ID)
      this.$set(this.temp_parcel_json, 'Delivery_Address_ID', this.parcel_json.Delivery_Address_ID)
      this.$set(this.temp_parcel_json.Pickup_Address, 'Name_1', this.parcel_json.Pickup_Address.Name_1)
      this.$set(this.temp_parcel_json.Delivery_Address, 'Name_1', this.parcel_json.Delivery_Address.Name_1)
      this.$set(this.temp_parcel_json.Pickup_Address, 'Street_1', this.parcel_json.Pickup_Address.Street_1)
      this.$set(this.temp_parcel_json.Delivery_Address, 'Street_1', this.parcel_json.Delivery_Address.Street_1)
      this.$set(this.temp_parcel_json.Pickup_Address, 'Postal_Code', this.parcel_json.Pickup_Address.Postal_Code)
      this.$set(this.temp_parcel_json.Delivery_Address, 'Postal_Code', this.parcel_json.Delivery_Address.Postal_Code)
      this.$set(this.temp_parcel_json.Pickup_Address, 'City', this.parcel_json.Pickup_Address.City)
      this.$set(this.temp_parcel_json.Delivery_Address, 'City', this.parcel_json.Delivery_Address.City)
      this.$set(this.temp_parcel_json.Pickup_Address, 'Country_Name', this.parcel_json.Pickup_Address.Country_Name)
      this.$set(this.temp_parcel_json.Delivery_Address, 'Country_Name', this.parcel_json.Delivery_Address.Country_Name)
    },

    // ************************ Toogle  Editable ************************
    // Changes to edit mode or closes it again. Edit mode is only possible if
    // not already another component is in edit mode
    toggleEditable () {
      // Close the edit mode
      if (this.isEditing) {
        this.close()
      } else {
        // Open the edit mode if not another component is in editing
        if (this.editInProgress) {
          window.bus.$emit('openWarningModal', 'You can only update one section at the same time. Please close the other one to edit here.')
        } else {
          // populate the addresses array with the already selected addresses
          this.addFoundAddress(this.temp_parcel_json.Delivery_Address, 'delivery')
          this.addFoundAddress(this.temp_parcel_json.Pickup_Address, 'pickup')
          this.isEditing = true
          window.bus.$emit('edit_in_progress')
        }
      }
    },

    // ************************ New Pickup address was chosen from dopdown ************************
    update_Pickup_Address (addressItem) {
      this.temp_parcel_json.Pickup_Address_ID = addressItem.value
      this.temp_parcel_json.Pickup_Address = {}
      this.temp_parcel_json.Pickup_Address.Address_ID = addressItem.value
      this.temp_parcel_json.Pickup_Address.Name_1 = addressItem.address_object.Name_1.substring(0, 75)
      this.temp_parcel_json.Pickup_Address.Street_1 = addressItem.address_object.Street_1
      this.temp_parcel_json.Pickup_Address.Postal_Code = addressItem.address_object.Postal_Code
      this.temp_parcel_json.Pickup_Address.City = addressItem.address_object.City
      this.temp_parcel_json.Pickup_Address.Country_Name = addressItem.address_object.Country_Name
    },

    // ************************ New delivey address was chosen from dopdown ************************
    update_Delivery_Address (addressItem) {
      this.temp_parcel_json.Delivery_Address_ID = addressItem.value
      this.temp_parcel_json.Delivery_Address = {}
      this.temp_parcel_json.Delivery_Address.Address_ID = addressItem.value
      this.temp_parcel_json.Delivery_Address.Name_1 = addressItem.address_object.Name_1.substring(0, 75)
      this.temp_parcel_json.Delivery_Address.Street_1 = addressItem.address_object.Street_1
      this.temp_parcel_json.Delivery_Address.Postal_Code = addressItem.address_object.Postal_Code
      this.temp_parcel_json.Delivery_Address.City = addressItem.address_object.City
      this.temp_parcel_json.Delivery_Address.Country_Name = addressItem.address_object.Country_Name
    },

    getAddresses (search, type) {
      if (this.currentSearchDebounce) {
        this.currentSearchDebounce.cancel()
      }
      this.currentSearchDebounce = debounce(this.startAddressSearch, 300)
      this.currentSearchDebounce(search, type)
    },

    // ************************ Searches for the addresses through the api ************************
    startAddressSearch (search, type) {
      if (search === '') {
        return
      }
      var countryID = this.temp_parcel_json.Country_ID
      var isForward = this.temp_parcel_json.Is_Forward
      // Addressmodel for the search
      var addressSearchModel:SearchAddressModel = {
        Customer_ID: this.parcel_json.Customer_ID,
        Search_Text: search,
        Maximum_Number_Of_Rows: 10
      } as SearchAddressModel
      if ((isForward && type === 'delivery') || (!isForward && type === 'pickup')) {
        addressSearchModel.Country_ID = countryID
      }
      webApi.address.get_Address_List(addressSearchModel)
        .then((response) => {
          if (type === 'delivery') {
            this.found_delivery_addresses = []
          } else {
            this.found_pickup_addresses = []
          }
          var responseAddress = response.data as any
          responseAddress.forEach(address => {
            // Build the  string shown in the dropdown
            this.addFoundAddress(address, type)
          })
        }).catch((response) => {
          window.bus.$emit('openErrorModal', 'error loading event info: ' + response.data.ExceptionMessage)
        })
    },

    /**
     * Adds an adress to the addresses array
     */
    addFoundAddress (address, type) {
      if (!address) {
        return
      }
      var addressLabel =
              address.Name_1.substring(0, 40) +
              ', ' +
              address.Street_1.substring(0, 40) +
              ', ' +
              address.Postal_Code.substring(0, 20) +
              ', ' +
              address.City.substring(0, 20) +
              ', ' +
              address.Country_Name.substring(0, 20)

      var addressObject = {
        label: addressLabel,
        value: address.Address_ID,
        address_object: address
      }
      if (type === 'delivery') {
        this.found_delivery_addresses.push(addressObject)
      } else {
        this.found_pickup_addresses.push(addressObject)
      }
    },

    // ************************ Checks if fields were changed and saves them to the DB ************************
    save () {
      this.saving = true
      // New addresses chosen?
      if (this.parcel_json.Pickup_Address_ID !== this.temp_parcel_json.Pickup_Address_ID ||
                        this.parcel_json.Delivery_Address_ID !== this.temp_parcel_json.Delivery_Address_ID ||
                        this.parcel_json.Contact_ID !== this.temp_parcel_json.Contact_ID) {
        // call update parcel web API
        // Call the api and pass the filtered columns and values
        webApi.parcel.update_Parcel(this.temp_parcel_json)
          .then((response) => {
            // Parcel was succesfully updated so we update the blockContent
            this.$toast('Your change to the addresses got updated', constants.defaultToastOptions())
            this.$emit('parcelUpdated')
            this.isEditing = false
            this.saving = false
            window.bus.$emit('edit_in_progress')
          }).catch((response) => {
            window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
            this.saving = false
          })
        // update the modal with the new information
      } else {
        // Nothing was changed, so throw a warning
        window.bus.$emit('openWarningModal', "Didn't you forget something? Nothing was changed.")
        this.saving = false
      }
    },

    //* ****************************************** Create Address Functions *************************************
    // Show the Create Address modal
    show_Create_Delivery_Address () {
      this.create_delivery_address_shown = true
    },
    // Show the Create Address modal
    show_Create_Pickup_Address () {
      this.create_pickup_address_shown = true
    },
    close_Address () {
      this.create_delivery_address_shown = false
      this.create_pickup_address_shown = false
    },
    pickup_Address_Created (addressModel) {
      var addressItem = {
        value: addressModel.Address_ID,
        address_object: {
          Name_1: addressModel.Name_1.substring(0, 75),
          Street_1: addressModel.Street_1,
          Postal_Code: addressModel.Postal_Code,
          City: addressModel.City,
          Country_Name: addressModel.Country_Name,
          Address_ID: addressModel.Address_ID
        }
      }
      this.addFoundAddress(addressItem.address_object, 'pickup')
      this.update_Pickup_Address(addressItem)
      this.create_pickup_address_shown = false
    },
    delivery_Address_Created (addressModel) {
      var addressItem = {
        value: addressModel.Address_ID,
        address_object: {
          Name_1: addressModel.Name_1.substring(0, 75),
          Street_1: addressModel.Street_1,
          Postal_Code: addressModel.Postal_Code,
          City: addressModel.City,
          Country_Name: addressModel.Country_Name,
          Address_ID: addressModel.Address_ID
        }
      }

      this.addFoundAddress(addressItem.address_object, 'delivery')
      this.update_Delivery_Address(addressItem)
      this.create_delivery_address_shown = false
    },
    contactSet (contact) {
      this.temp_parcel_json.Contact_ID = contact.contactItem.Contact_ID
      this.temp_parcel_json.Contact_Name = contact.contactItem.Contact_Name
      this.temp_parcel_json.Contact_Phone = contact.contactItem.Contact_Phone
    }
  }
}
</script>

<style lang="scss">
    @import '../../variables.scss';

    .spl-parcel-detail-block {
        background-color: $parcelTimelineBackgroundColor;
        margin-bottom: 20px;
        padding: 20px 17px 30px 17px;
        position: relative;
        width: 100%;

        @include mobile() {
            padding-bottom: 20px;
        }
        &-error {
            background-color: $redBackgroundLight;
            border-left: 2px solid $red;

            .spl-parcel-detail-block__edit {
                background-image: url(../../assets/icon-tripple-dot-red.svg);

            }
        }
        &-error &__edit {
            &-open {
                background-image: url(../../assets/icon-close-red.svg);
            }
        }
        &-vertical {
            &:after {
                clear: both;
                content: '';
                display: block;
                float: none;
            }
            .spl-parcel-detail-block {
                &__label,
                &__body {
                    float: left;
                    min-height: 10px;
                    vertical-align: top;
                }
                &__label {
                    width: 16.6667%;

                    @include mobile() {
                        width: 100%;
                    }
                }
                &__body {
                    width: 41.6667%;

                    @include mobile() {
                        width: 100%;
                    }
                }
            }
        }
        &__edit {
            background-image: url(../../assets/icon-tripple-dot.svg);
            background-position: center center;
            background-repeat: no-repeat;
            cursor: pointer;
            height: 25px;
            position: absolute;
            right: 10px;
            top: 20px;
            transition: opacity $shortTransition ease-in-out;
            width: 25px;

            &:hover {
                opacity: 0.5;
            }
            &-open {
                background-image: url(../../assets/icon-close.svg);
            }
        }
        &__label {
            color: $mainInputColor;
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 5px;
        }
        &__body {
            .spl-button,
            .spl-textarea,
            .spl-dropdown {
                margin: 0 0 10px 0;
            }
            &__content {
                font-size: 12px;
                line-height: 1.7;

                &:after {
                    clear: both;
                    content: '';
                    display: block;
                    float: none;
                }
                &-blocks,
                &-edit {
                    margin-bottom: -20px;

                    .spl-parcel-detail-block__body__content {
                        &__label,
                        &__value {
                            width: 100%;
                        }
                        &__value {
                            margin-bottom: 20px;
                        }
                    }
                }
                &-edit .spl-parcel-detail-block__body__content {
                    &__label {
                        color: $parcelDetailBlockLabelColor;
                        font-family: $mono;
                        font-size: 9px;
                        font-weight: 700;
                        line-height: 12px;
                        letter-spacing: 1px;
                        margin-bottom: 10px;
                        text-transform: uppercase;
                    }
                    &__value {
                        .spl-input {
                            margin-bottom: 10px;
                        }
                    }
                }
                &__label,
                &__value {
                    float: left;
                    min-height: 10px;
                    vertical-align: top;
                    width: 50%;

                    @include mobile() {
                        width: 100%;
                    }
                }
                &__value {
                    font-weight: 600;

                    &-pre {
                        white-space: pre;
                    }
                    @include mobile() {
                        margin-bottom: 10px;
                    }
                }
            }
        }
        &__highlight {
            background-color: $tableRowBackgroundColorSelected;
            border-left: 2px solid $middleYellow;
            bottom: 0;
            color: $mainInputColor;
            font-size: 12px;
            font-weight: 400;
            margin: 30px -17px -30px -17px;
            padding: 15px;
        }
    }
    .spl-search-dropdown {
        background-color: #fff;
        border-radius: 4px;
        border: 1px solid $lightYellowBorder;
        color: $mainInputColor;
        cursor: pointer;
        font-size: 14px;
    }

    @include mobile () {
      .spl-parcel-detail-block {
        &__pickup-address,
        &__delivery-address {
          & .multiselect__option {
            white-space: normal;
          }

          & .multiselect__option--highlight:after {
            display: none;
          }
        }
      }
    }
</style>
